export default class BInput
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.b-input`;
	static inputSelector = () => `.b-input__input`;
	static focusedClass = () => `b-input--focused`;
	static filledClass = () => `b-input--filled`;

	static initialize()
	{
		this.addEventListeners();

		document.querySelectorAll(this.selector()).forEach(el => {
			(new this(el)).refreshFilled();
		});
	}

	static addEventListeners()
	{
		document.addEventListener("click", event => {
			if (event.target.matches(this.selector())) {
				const input = new this(event.target);

				input.getInputElement().focus();
			}
		});

		document.addEventListener("focus", event => {
			if (event.target.matches(this.inputSelector())) {
				const el = event.target.closest(this.selector());
				if (el) new this(el).setFocused();
			}
		}, {
			capture: true,
		});

		document.addEventListener("blur", event => {
			if (event.target.matches(this.inputSelector())) {
				const el = event.target.closest(this.selector());
				if (!el) return;
				const input = new this(el);
				input.unsetFocused();
				input.refreshFilled();
			}
		}, {
			capture: true,
		});
	}

	setFocused()
	{
		this.el.classList.add(BInput.focusedClass());
	}

	unsetFocused()
	{
		this.el.classList.remove(BInput.focusedClass());
	}

	getInputElement()
	{
		return this.el.querySelector(BInput.inputSelector());
	}

	getInputValue()
	{
		return this.getInputElement().value;
	}

	refreshFilled()
	{
		this.el.classList.toggle(BInput.filledClass(), this.getInputValue().trim().length);
	}
}
